const setEstateRestrictions = (
	socialProfile: UserSocialProfile | undefined,
	setVal: any,
	storesData: Store[] | undefined,
	isStoreReport: boolean
) => {
	if (socialProfile?.retail_user?.manager_of_region) {
		setVal("filters.regionId", socialProfile.retail_user.manager_of_region);
		setVal("filters.regionDisabled", true);
	} else if (socialProfile?.retail_user?.manager_of_area) {
		const filteredStores = storesData?.filter(
			({ area }) => area === socialProfile?.retail_user?.manager_of_area
		);

		setVal(
			"filters.regionId",
			filteredStores && filteredStores.length > 0
				? filteredStores[0].region
				: undefined
		);
		setVal("filters.regionDisabled", true);

		setVal("filters.areaId", socialProfile.retail_user.manager_of_area);
		setVal("filters.areaDisabled", true);
	} else if (socialProfile?.retail_user?.manager_of_store) {
		const filteredStores = storesData?.filter(
			({ id }) => id === socialProfile?.retail_user?.manager_of_store
		);

		setVal(
			"filters.regionId",
			filteredStores && filteredStores.length > 0
				? filteredStores[0].region
				: undefined
		);
		setVal("filters.regionDisabled", true);

		setVal(
			"filters.areaId",
			filteredStores && filteredStores.length > 0
				? filteredStores[0].area
				: undefined
		);
		setVal("filters.areaDisabled", true);

		if (!isStoreReport) {
			setVal("filters.storeId", socialProfile.retail_user.manager_of_store);
		}

		setVal("filters.storeDisabled", true);
	}
};

export default setEstateRestrictions;
